export const EmailAlertStatusService = Symbol.for('EmailAlertStatusService');
